<div class="p-6">
  <app-table
    [config]="meteringPointTableConfig"
    [data]="tableData"
    [(selectedElements)]="selectedElements"></app-table>
</div>
